module.exports = __webpack_public_path__ + "img/error.271789b2.svg";